module.exports = __webpack_public_path__ + "static/media/mirror.co.uk_news_world-news_astonishing-new-footage-shows-gorilla-8082168_plot.8626e33b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/mirror.co.uk_news_world-news_astonishing-new-footage-shows-gorilla-8082168_plot.png
// module id = 397
// module chunks = 0